import React, { useEffect } from 'react';
import BreadCrumb from "../../common/breadcrumb";
import ServicesConstruction from "./services-construction";
import ServicesArchitecture from "./services-architecture";
import ServicesEngineering from "./services-engineering";
import ServicesConsultancy from "./services-consultancy";
import ServicesImportSupply from "./services-import-supply";
import SEO from "../../../data/seo";
import HeaderTwo from "../../../layout/headers/header-two";
import FooterOne from "../../../layout/footers/footer-one";
import { useParams, useNavigate } from "react-router-dom";
import servicesData from "../../../data/services-data";
import FooterTwo from '../../../layout/footers/footer-two';

const ServicesDetails = () => {

    function getService(id) {
        console.log(id);
        if (id === 'architecture') {
            return <ServicesArchitecture />
        } else if (id === 'construction') {
            return <ServicesConstruction />
        } else if (id === 'engineering') {
            return <ServicesEngineering />
        } else if (id === 'consultancy') {
            return <ServicesConsultancy />
        } else if (id === 'import-supply') {
            return <ServicesImportSupply />
        }
        return null;
    }
    const params = useParams();
    const singleData = servicesData?.find((service) => service.id === params.id);
    const navigate = useNavigate();
    useEffect(() => {
        if (!singleData) {
            navigate("/404-error");
        }
    }, []);
    if (!singleData) {
        return null;
    }
    const firstThreeWords = singleData?.title.split(' ').slice(0, 3).join(' ') + '...';
    let ServiceComponent = getService(params.id);
    return (
        <>
            <SEO pageTitle={singleData?.title}
                keywords={[
                    "Architectural Service",
                    "architecture news",
                    "services architecture",
                    "Architectural design and drawing",
                    "3D Imagery",
                    "Architectural Drafting and Design",
                    "Structural design and drawing services",
                    "Structural design engineers in Dhaka",
                    "Architectural services in Niketon, Dhaka",
                    "House design and drawing price in Bangladesh"
                ]} />
            <HeaderTwo />
            <BreadCrumb title={firstThreeWords} innerTitle={singleData?.title} />
            {ServiceComponent}
            <FooterTwo />
        </>
    );
};

export default ServicesDetails;
